const { abstractResource } = require('./abstractResource')
const {sh_code} = require('../product/sh_code')


const service = abstractResource('PRODUCTS')

const Product = {
    ...service('products'),
    get_form(){
        return{
            advised_price: 0.0,
            barcode: null,
            brand: null,
            buying_price: 0.0,
            description: null,
            manufacturer: null,
            manufacturer_description: null,
            manufacturer_sku: null,
            name: null,
            origin_country: null,
            picture: null,
            products: [],
            reference: null,
            selling_price: 0.0,
            season: null,
            service: false,
            sh_code: null,
            sku: null,
            stock: 0,
            tags: [],
            seasons: [],
            taxes: [],
            weight: 0.0,
            product_variation_params: [],
            is_variation: false,

        }
    },

    get_season_choices(){
      return[
          {text: "Hiver", value: "winter"},
          {text: "Printemps", value: "spring"},
          {text: "Eté", value: "summer"},
          {text: "Automne", value: "autumn"},
      ]
    },

    get_sh_code() {
        return sh_code
    }
}

const ProductParams = (route) => ({
    ...service(route),
    get_form(){
        return{
            name: null,
        }
    }
})

const ProductSeason = ProductParams('product-seasons')

const ProductBrand = ProductParams('product-brands')

const ProductTags = ProductParams('product-tags')

const ProductVariationParam = ProductParams('product-variation-params')

const ProductVariationParamItem = {
    ...service('product-variation-param-items'),
    get_form(){
        return{
            ...ProductParams('').get_form(),
            product_variation_param: null,
        }
    }
}

const ProductAssembly = {
    ...service('product-assemblies'),
    get_form(){
        return{
            product: null,
            linked_product: null,
            quantity: 0,
        }
    }
}

const ProductPack = {
    ...service('product-packs'),
    get_form(){
        return{
            name: null,
            quantity: 0,
            price: 0.0,
            product: null,
        }
    }
}

const ProductStorage = {
    ...service('product-storages'),
    get_form(){
        return{
            place: null,
            product: null,
            stockage_area: null,
            stock_alert: null,
            real_stock: 0,
            available_stock: 0,
            reserve_stock: 0,
            to_come_stock: 0,
            supply_stock: 0,
        }
    }
}

const StockMovement = {
    ...service('stock-movements'),
    get_form(){
        return{
            departure_area: null,
            target_area: null,
            status: 'pending',
            type: null,
            number: null,
            company: "1",
        }
    },
    get_status(){
        return[
            {text: "En attente", value: "pending"},
            {text: "Terminé", value: "finish"},
            {text: "Annulé", value: "canceled"},
        ]
    },
    get_type(){
      return[
          {text: "Entrée", value: "entrance"},
          {text: "Sortie", value: "exit"},
          {text: "Mouvement", value: "movement"},
      ]
    }
}
const StockMovementLine = {
    ...service('stock-movement-lines'),
    get_form(){
        return{
            product: null,
            quantity: null,
            stock_movement: null,
        }
    },
}

const StockageArea = {
    ...service('stockage-areas'),
    get_form(){
        return{
            name: null,
            description: null,
            address: null,
            contact: null,
            postcode: null,
            city: null,
            country: null,
            email: null,
            phone: null,
            products: [],
            delivery_cost: null,
            type: null,
            is_active: true,
            replace_names: false,
        }
    },

    get_type_choices(){
        return[
            {value: "warehouse", text: "Entrepôt"},
            {value: "store", text: "Magasin"},
        ]
    }
}

const Dashboard = {
    get_filters(){
        return{
            product_storages: {
                filters: {
                    product_storage__to_restock: {
                        label: "Produits à réapprovisionner",
                        value: false
                    },
                    product_storage__negative_available_stock: {
                        label: "Stocks négatifs",
                        value: false,
                    },
                    product_storage__under_stock_alert: {
                        label: "Produits en dessous du stock d'alerte",
                        value: false,
                    },
                },
                label: "Stocks"
            },
        }
    }
}

module.exports = {
    StockageArea,
    ProductSeason,
    ProductBrand,
    ProductTags,
    ProductVariationParam,
    ProductVariationParamItem,
    ProductParams,
    Product,
    ProductAssembly,
    ProductPack,
    ProductStorage,
    StockMovement,
    StockMovementLine,
    Dashboard,
}